import React, { useEffect } from 'react';
import styled from 'styled-components';
import deleteIcon from '../../asset/icon/delete.png';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import { ChangeModalFrame } from '../../shared/component/modal/ChangeModalFrame';
import { getSettingsMessage } from '../../shared/constants/pageMessages';
import { useModalStore } from '../../shared/store/portal/modalStore';
import ApprovalRequestSection from './ApprovalRequestSection';

const ApprovalRequestModal: React.FC = () => {
  const { isClosing, clearModal } = useModalStore();
  const handleClose = () => clearModal();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') clearModal();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [clearModal]);

  return (
    <ChangeModalFrame
      $isClosing={isClosing}
      onClick={(event) => event.stopPropagation()}
    >
      <DesktopBody>
        <HeaderRow>
          <DesktopTitle>{getSettingsMessage('SETTINGS_APPROVAL_REQUESTS')}</DesktopTitle>
          <UniversalIconBtn
            size="small"
            border={false}
            isTransparent
            hoverOpacity
            backgroundImg={deleteIcon}
            onClick={handleClose}
            aria-label="Close"
          />
        </HeaderRow>
        <ApprovalRequestSection />
      </DesktopBody>
    </ChangeModalFrame>
  );
};

const DesktopBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5vw;
  overflow: hidden;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 3vh;
`;

const DesktopTitle = styled.h2`
  min-width: 0;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  ${({ theme }) => theme.typography.Body_02_1};
`;

export default ApprovalRequestModal;
